import React, { useEffect } from "react";
import "./Xenophobia.css";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import XenophobiaHero from "./components/XenophobiaHero";
import BeforeStart from "./components/BeforeStart";
import Consider from "./components/Consider";
import Design from "./components/Design";
import { NavbarProvider } from "./context/NavbarContext";
import { DesignCardsProvider } from "./context/DesignCardsContext";
import Tools from "./components/Tools";

export default function Xenophobia() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="xpb">
      <NavbarProvider>
        <Header />
        <Navbar />
        <XenophobiaHero />
        <BeforeStart />
        <Consider />
        <DesignCardsProvider>
          <Design />
        </DesignCardsProvider>
        <Tools />
      </NavbarProvider>
    </div>
  );
}
